
export default function stripHtml(val = '', addSuffix = true, strict = true) {
	if (!val) return ''
	const regex = /(<([^>]+)>)/ig;
    return String(val).replace(regex, "");
}

